import { Link } from "gatsby"
// import { capitalize as cap } from "lodash"

function LetterOl({ actLink, actName, letters }) {
  return (
    <li
      sx={{
        fontFamily: "body",
        fontWeight: "body",
        fontFeatureSettings: "'kern' 1, 'liga' 1, 'dlig' 1, 'case' 1, 'smcp' 1",
        counterReset: "section",
        textAlign: "center",
        paddingTop: "2rem"
      }}
    >
      <Link
        to={`/${actLink}/`}
        sx={{ variant: "links.nav", textDecoration: "underline" }}
      >
        {actName}
      </Link>
      <ol
        sx={{
          paddingTop: "2rem",
          paddingBottom: "2rem",
          marginLeft: "4rem",
          textAlign: "left"
        }}
      >
        {letters.map((letter) => {
          return (
            <li
              key={letter.id}
              data-order={letter.chapter}
              sx={{
                paddingBottom: "1rem",
                fontFeatureSettings:
                  "'kern' 1, 'liga' 1, 'dlig' 1,'case' 1, 'onum' 1, 'tnum' 1, 'smcp' 0",
                counterIncrement: "section",
                "&:before": {
                  content: "attr(data-order) '. '",
                  fontFeatureSettings:
                    "'kern' 1, 'liga' 1, 'dlig' 1,'case' 1, 'onum' 1, 'tnum' 1, 'smcp' 0",
                  variant: "text.listMarker",
                  display: "block",
                  float: "left",
                  height: "3rem",
                  marginRight: "1rem"
                }
              }}
            >
              <Link
                to={letter.slug}
                sx={{ variant: "links.body", fontStyle: "italic" }}
              >
                In which {letter.in_which}
              </Link>
            </li>
          )
        })}
      </ol>
    </li>
  )
}

export default LetterOl
